import { useState } from 'react';
import { errorMessage, fileUploadConfig } from '@helpers/Constants';
import { FileDropProp } from './Models';

export const useFileDropZone = ({
  setFile,
  setError,
}: FileDropProp): {
  isDragging: boolean;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
} => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  /**
   * Handles the drop event for a file drop zone.
   * Prevents the default browser behavior, updates the dragging state,
   * and processes the dropped file. Validates the file size and format,
   * and sets appropriate error messages or updates the file state.
   *
   * @param e - The drag event triggered when a file is dropped.
   */
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files?.[0];
    if (droppedFile) {
      if (droppedFile.size > fileUploadConfig.MAX_FILE_SIZE) {
        setError(errorMessage.MAX_FILE_SIZE_ERROR);
      } else if (!/\.(jpg|png)$/i.test(droppedFile.name)) {
        setError(errorMessage.FILE_FORMATS);
      } else {
        setError('');
        setFile(droppedFile);
      }
    }
  };

  return {
    isDragging,
    handleDragOver,
    handleDragLeave,
    handleDrop,
  };
};
